module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.all), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'bookshelf',
          params: {
            catid: item.id
          },
          query: {
            name: item.category
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.category) + "\n    ")])
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b8fdd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/category/all.vue
// module id = 312
// module chunks = 0